import { Product } from "../products/product";

export type TaskId = string;

export enum ProductSearchAction {
  SEARCH = "search",
  SELECT = "select",
}

// Returned by a "select" instead of the id list when the selection is stored
// server-side as a filter (avoid_counting_products).
export interface SelectAllResult {
  select_all: boolean;
}

export interface ProductSearchResult {
  count: number;
  results: Product[];
  error?: boolean;
  has_next?: boolean;
}
